import { render, staticRenderFns } from "./DocumentPortalControls.vue?vue&type=template&id=7b234cb6&"
import script from "./DocumentPortalControls.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalControls.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports